/** Enum for a value that can be passed to a pdf to check or uncheck a checkbox */
export enum PdfCheckboxValue {
	Checked = 'Yes',
	Unchecked = 'Off',
}
